import { useState } from "react";
import { CardElement } from "@stripe/react-stripe-js";
import { useStripe, useElements } from "@stripe/react-stripe-js";
import api from "http";
import { toast } from "react-toastify";
import FullPageLoader from "Components/FullPageLoader/FullPageLoader";
import NumberConversion from "Utils/NumberConversion";
import CustomButtonNew from "Common/CustomButtonNew/CustomButtonNew";

const PayWithCardForm = ({ Model, stripeSettingId, patientInfo, onCloseinsurancePopup, ClosePaywithcard }) => {

    const stripe = useStripe();
    const elements = useElements();
    const [state, setstate] = useState({
        isLoading: false,
    })
    const [message, setMessage] = useState(null)
    const [isProcessing, setIsProcessing] = useState(false)

    const handleSubmit = async (e) => {
        if (!stripe || !elements) {

            return;
        }

        setIsProcessing(true);
        // amount: 6510000, currency: 'usd', payment_method: 'card'
        const { paymentMethod, error } = await stripe.createPaymentMethod({
            type: 'card',
            card: elements.getElement(CardElement),
        });
        try {
            elements.submit().then(res => {
                setstate(prev => ({ ...prev, isLoading: true }))

                api.post(`${process.env.REACT_APP_TC_PMS}/api/Payment/CreateInsurancePaymentIntent`, {
                    items: [
                        {
                            id: paymentMethod.id,
                            amount: Number(Model.paidAmount)
                        }
                    ],
                    insurancePlanId: Model.insurancePlanId,
                    stripeSettingId: stripeSettingId,
                    paymentSource: Model.paymentSource,
                    paymentVia: Model.paymentSource === "Terminal" ? "Card" : "",
                    payerName: Model.payerName,
                    payerId: Model.payerId,
                    receivedDate: Model.receivedDate,
                    description: Model.notes
                }).then(res => {
                    stripe.confirmPayment({

                        // elements: elements,
                        clientSecret: res.data.dataModel.clientSecret,

                        confirmParams: {
                            payment_method: paymentMethod.id,
                            // Make sure to change this to your payment completion page

                            return_url: `${window.location.origin}/completion`,
                        },

                        redirect: 'if_required'
                    }).then(data => {
                        if (data.error) {
                            setstate(prev => ({ ...prev, isLoading: false }))
                            setIsProcessing(false);
                            toast(data.error.message, { type: 'error' })


                        } else {
                            setstate(prev => ({ ...prev, isLoading: false }))
                            if (data.paymentIntent) {
                                toast(`Payment Successfully`, { type: 'success' })
                                ClosePaywithcard(true)
                                onCloseinsurancePopup(true)
                            }
                        }


                    }).catch(err => {
                        setstate(prev => ({ ...prev, isLoading: false }))
                    })

                }).catch(err => {


                    setstate(prev => ({ ...prev, isLoading: false }))
                    setIsProcessing(false);
                })

            }).catch(err => {
                if (err.message === `Cannot read properties of undefined (reading 'id')`) {
                    toast.info('Card Information is missing or incorrect !')
                }

                setIsProcessing(false);
                setstate(prev => ({ ...prev, isLoading: false }))
            })
        } catch (error) {
        }

        if(error){
            toast(error?.message, { type: 'error' })
        }

    }
    return (
        <>
            {state.isLoading && <FullPageLoader allowFullScreen={true} />}
            <form id="payment-form">

                <span className="flex items-center text-sm"><span className="mr-1 font-bold text-black/50">Amount: </span><span className="flex items-center text-base font-bold text-black">
                    <img src="/img/patientBalanceBlack.svg" alt="dollar" />{NumberConversion(Model.paidAmount, 'remove$')}</span></span>
                <CardElement options={{
                    classes: { base: 'bg-gray-200/50 my-3 shadow-sm rounded-md p-2 ' },

                    // style: {
                    //     base: {
                    //         // iconColor: '#c4f0ff',

                    //         padding: '20px', backgroundColor: '#f7f7f7',

                    //         color: 'black',
                    //         // fontWeight: '500',
                    //         // fontFamily: 'Roboto, Open Sans, Segoe UI, sans-serif',
                    //         // fontSize: '16px',
                    //         fontSmoothing: 'antialiased',
                    //         ':-webkit-autofill': {
                    //             // color: '#fce883',
                    //         },
                    //         '::placeholder': {
                    //             // color: '#87BBFD',
                    //         },
                    //     },
                    //     invalid: {
                    //         // iconColor: '#FFC7EE',
                    //         // color: '#FFC7EE',
                    //     },
                    // },
                    hidePostalCode: true,

                }} id="payment-element" />

                <div id="" className="flex justify-end w-full">
                    <CustomButtonNew disabled={isProcessing || !stripe || !elements} className={'font-bold !text-black/70 hover:!text-black'} onClick={handleSubmit} variant={'clear'} label={isProcessing ? "Processing ... " : "Pay now"} />

                </div>

                {/* Show any error or success messages */}
                {message && <div id="payment-message">{message}</div>}
            </form>
        </>
    )
}

export default PayWithCardForm
